<!-- <div class="chart-container">
    <canvas  id="MyChart" >{{ chart }}</canvas>
</div> -->
<div class="">
    <div >
        <canvas style="width:100%"  id="myChart" width="900" height="500" id="mychart" #mychart></canvas>
    </div>
</div>